export const visibilityBtnSx = (theme) => ({
  color: theme.palette.secondary.main,
});
